import { useEffect, useRef } from "react";
import useModal from "../../hooks/useModal";
import Button from "../../components/form-controls/Button";
import { useForm } from "react-hook-form";
import Input from "../../components/form-controls/Input";
import { SupportService } from "../../services/SupportService";
import { AlertService } from "../../services/Alert";

interface AddModalProps {
    show: boolean;
    onRequestClose: (refresh: boolean) => void;
    payload: any
}

function AddModal({ show, onRequestClose, payload }: AddModalProps) {

    const modalRef = useRef<HTMLDivElement>(null)

    useModal(modalRef, show)

    const defaultValues = {
        id_help: '',
        module_key: '',
        title: '',
        url: ''
    }
    const { register, handleSubmit, reset, watch, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });
    const submit = async (data) => {
        try {
            payload != null ? await SupportService.editLink(data) : await SupportService.addLink(data);
            await onRequestClose(true);
            reset(defaultValues);
            AlertService.toastSuccess('Se ha guardado correctamente el link de ayuda')
        } catch (error) {
            console.log(error)
            AlertService.error('Error', 'No se pudo guardar el link de ayuda ¡Intenta de nuevo!')
        }

    }
    
    useEffect(() => {
        // if( payload ) {
        //     reset({
        //         module_key: payload.module_key,
        //         title: payload.title,
        //         url: payload.url
        //     })
        // } else {
        //     reset(defaultValues)
        // }

        reset({
            id_help: payload?.id ? payload.id : defaultValues.id_help,
            module_key: payload && payload.module_key ? payload.module_key : defaultValues.module_key,
            title: payload?.title ? payload.title : defaultValues.title,
            url: payload?.url ? payload.url : defaultValues.url,
        })

    }, [payload])

    return (
        <div className="modal fade" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog " role="document">

                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" >{watch('id_help') ? 'Editar' : 'Agregar'} link</h4>
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input label={'Module Key *'} errors={errors.module_key} {...register('module_key', { required: true })} />
                            </div>
                            <div className="mb-3">
                                <Input
                                    label={'Titulo *'}
                                    errors={errors.title} {...register('title', { required: true, maxLength: { value: 40, message: '40' } })}
                                    currentLength={watch('title').length}
                                    maxLength={40}
                                />
                            </div>
                            <div className="mb-3">
                                <Input label={'URL *'} errors={errors.url} {...register('url', { required: true, pattern: { value: new RegExp(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig), message: 'Agrega un valor de URL valido' } })} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>Cancelar</button>
                            <Button type="submit" className="btn btn-primary btn-sm" onClick={handleSubmit(submit)} disabled={!isValid} isLoading={isSubmitting}>{watch('id_help') ? 'Editar' : 'Guardar'}</Button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    )

}
export default AddModal;